import { StaticMap } from '@/reports/maps/StaticMap/StaticMap';
import useMrRogersNpanxx from '@/reports/shared/useMrRogersNpanxx/useMrRogersNpanxx';
import { Icons, Stack } from '@/theme/index';
import { TileItem, SectionTitle } from '../components';

export interface FraudPhoneLocationDetailsProps {
  phoneNumber: string;
  timeZone?: string | null;
}

export function FraudPhoneLocationDetails({
  phoneNumber,
  timeZone,
}: FraudPhoneLocationDetailsProps) {
  // HOOKS;
  const npanxxResult = useMrRogersNpanxx({ phoneNumber });
  let cityStateCountryString = '-';

  let latitude: number | undefined;
  let longitude: number | undefined;
  let zipCode;

  if (npanxxResult.isSuccess && npanxxResult.data) {
    const { data } = npanxxResult;
    zipCode = data[0].zipcode || '-';
    latitude = data[0].latitude;
    longitude = data[0].longitude;
    if (data[0].city && data[0].state && data[0].country) {
      cityStateCountryString = `${data[0].city}, ${data[0].state}, ${data[0].country}`;
    }
  }

  const formatTimeZone = (timeZone: string) => {
    if (timeZone.includes('_')) {
      return timeZone.replace('_', ' ');
    }
    return timeZone;
  };

  return (
    <Stack>
      <SectionTitle>Location Details</SectionTitle>
      <Stack direction="row" flexWrap="wrap" justifyContent="space-between">
        <Stack
          justifyContent="space-between"
          gap={1.25}
          flexWrap="wrap"
          width={{ xs: '100%', lg: '48%' }}
        >
          <TileItem
            title="Location:"
            text={cityStateCountryString}
            IconComponent={Icons.Place}
          />
          <TileItem
            title="Zip Code:"
            text={zipCode}
            IconComponent={Icons.Tag}
          />
          <TileItem
            title="Time Zone:"
            text={formatTimeZone(timeZone || '-')}
            IconComponent={Icons.WatchLater}
          />
        </Stack>
        <Stack mt={{ xs: 2, md: 2, lg: 0 }} width={{ xs: '100%', lg: '48%' }}>
          {latitude && longitude && (
            <StaticMap
              zoomLevel={6}
              streetsView
              longitude={longitude}
              latitude={latitude}
              width={768}
              height={350}
              withMarker
            />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}
